module.exports = __webpack_public_path__ + "img/95.8afbf275.jpg";